import React from 'react'
import { Stack, Typography } from '@mui/material'


const style = {
    minWidth: '50%',
    overflow: 'hidden',
    padding: '16px',
    textAlign: 'center',
    color: '#ffffff',
    borderRadius: '16px',
    backgroundColor: '#E5591E',
}

const EventsFocus = () => {
    return (
        <Stack sx={style}>
            <Typography variant="h3" sx={{color: '#fff', fontWeight: 700, fontSize: '2rem'}}>Ven. 12 Avr. 2026</Typography>
            <Stack spacing={1} direction={{xs: 'row', md: 'column', lg: 'column'}} justifyContent={'center'} sx={{color: '#fff', p: 2}}>
                <Typography variant="h4" sx={{ fontSize: '1rem'}} >21:00</Typography>
                <Typography variant="h4" sx={{ fontSize: '1rem'}}>Paris</Typography>
                <Typography variant="h4" sx={{ fontSize: '1rem'}}>(UTC +1)</Typography>
            </Stack>
        </Stack>
    )
}

export default EventsFocus